<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="eight wide column">
            <Breadcrumb>
              <div class="active section">
                Relatório de Listagem de Contratos por Colaborador
              </div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div ref="modal" class="ui large modal" style="top: 40px">
        <iframe
          ref="viewer"
          width="100%"
          style="height: calc(100vh - 100px)"
        ></iframe>
      </div>
      <form
        :class="['ui small', { error: anyError }, 'form']"
        v-autocomplete-off
      >
        <div class="ui padded grid">
          <div v-show="loading" class="ui active inverted dimmer">
            <div class="ui text loader">Carregando...</div>
          </div>
          <div class="row">
            <div class="ten wide column">
              <div class="four wide field">
                <label for="cotract-by-collaborator-report-state"
                  >Situação</label
                >
                <select
                  id="cotract-by-collaborator-report-state"
                  class="ui dropdown"
                  v-model="form.state"
                >
                  <option
                    v-for="(state, index) in states"
                    :key="index"
                    :value="state.value"
                  >
                    {{ state.description }}
                  </option>
                </select>
              </div>
              <div class="ui required field">
                <label for="">Data de Criação</label>
              </div>
              <div class="inline fields">
                <div
                  :class="['four wide', { error: errors.start_date }, 'field']"
                  :data-content="errorsTo('due_date')"
                >
                  <label for="cotract-by-collaborator-report-due-date"
                    >De:</label
                  >
                  <input
                    type="text"
                    v-mask="'##/##/####'"
                    id="cotract-by-collaborator-report-due-date"
                    v-model="form.start_date"
                  />
                </div>
                <div
                  :class="['four wide', { error: errors.end_date }, 'field']"
                  :data-content="errorsTo('end_date')"
                >
                  <label for="cotract-by-collaborator-report-date-of-payment"
                    >Até</label
                  >
                  <input
                    type="text"
                    v-mask="'##/##/####'"
                    id="cotract-by-collaborator-report-date-of-payment"
                    v-model="form.end_date"
                  />
                </div>
              </div>
              <div class="field">
                <label for="cotract-by-collaborator-report-collaborators">
                  Colaboradores
                </label>
                <select
                  id="cotract-by-collaborator-report-collaborators"
                  class="ui fluid search dropdown"
                  multiple=""
                  v-model="form.collaborators"
                >
                  <option
                    v-for="(collaborator, index) in collaborators"
                    :key="index"
                    :value="collaborator.id"
                  >
                    {{ collaborator.name }} - {{ collaborator.id }}
                  </option>
                </select>
              </div>
              <div class="field">
                <label for="cotract-by-collaborator-report-plans">
                  Planos
                </label>
                <select
                  id="cotract-by-collaborator-report-plans"
                  class="ui fluid search dropdown"
                  multiple=""
                  v-model="form.plans"
                >
                  <option
                    v-for="(plan, index) in plans"
                    :key="index"
                    :value="plan.id"
                  >
                    {{ plan.description }} - {{ plan.id }}
                  </option>
                </select>
              </div>
              <div class="field">
                <label for="cotract-by-collaborator-report-payment_methods">
                  Métodos de Pagamento
                </label>
                <select
                  id="cotract-by-collaborator-report-payment-methods"
                  class="ui fluid search dropdown"
                  multiple=""
                  v-model="form.payment_methods"
                >
                  <option
                    v-for="(payment_method, index) in paymentMethods"
                    :key="index"
                    :value="payment_method.name"
                  >
                    {{ payment_method.description }}
                  </option>
                </select>
              </div>
              <div class="ui divider"></div>
              <div class="field">
                <button
                  @click="run"
                  type="button"
                  name="run"
                  class="ui submit blue button"
                >
                  <i class="play icon"></i>Gerar Relatório
                </button>
              </div>
            </div>
          </div>
          <!-- row -->
        </div>
        <!-- grid -->
      </form>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import ContractEnum from '@/enumerations/contract_enum';
import { mapGetters } from 'vuex';

export default {
  components: { Breadcrumb, PageLayout },

  data() {
    return {
      loading: false,
      loaded: false,
      errors: {},
      collaborators: [],
      plans: [],
      form: {
        state: null,
        plans: [],
        payment_methods: [],
        collaborators: [],
        start_date: this.$moment().startOf('month').format('DD/MM/YYYY'),
        end_date: this.$moment().endOf('month').format('DD/MM/YYYY')
      },
      states: ContractEnum.states
    };
  },

  computed: {
    anyError() {
      return !_.isEmpty(this.errors);
    },

    ...mapGetters({
      paymentMethods: 'settings/paymentMethods'
    })
  },

  mounted() {
    this.getData();

    $('.ui.dropdown').dropdown();
  },

  methods: {
    async getData() {
      this.loading = true;

      const usersQuery = {
        all: true,
        q: {
          rule_eq: 'collaborator',
          s: ['name asc']
        }
      };

      const plansQuery = {
        q: {
          enable_eq: true,
          s: ['id asc']
        }
      };

      try {
        const usersResponse = await Api.users.search(usersQuery);
        this.collaborators = _.clone(usersResponse.data.users);

        const plansResponse = await Api.plans.search(plansQuery);
        this.plans = _.clone(plansResponse.data.plans);
      } catch (e) {
        this.$toast.show('Erro ao carregar dados', 'error');
        throw e;
      } finally {
        this.loading = false;
      }
    },

    errorsTo(key) {
      const errors = _.isEmpty(this.errors[key]) ? [] : this.errors[key];
      return errors.join(', ');
    },

    run() {
      this.loading = true;
      let data = {
        report: 'contracts_by_collaborator',
        CREATED_AT_START: this.$moment(
          this.form.start_date,
          'DD/MM/YYYY'
        ).format('YYYY-MM-DD'),
        CREATED_AT_END: this.$moment(this.form.end_date, 'DD/MM/YYYY').format(
          'YYYY-MM-DD'
        )
      };

      if (this.form.collaborators.length > 0) {
        data.COLLABORATOR_IDS = this.form.collaborators.join(',');
      }

      if (this.form.plans.length > 0) {
        data.PLAN_IDS = this.form.plans.join(',');
      }

      if (this.form.payment_methods.length > 0) {
        const covenants = this.form.payment_methods
          .map(x => `\\'${x}\\'`)
          .join(',');
        data.COVENANTS = covenants;

        let covenantsDescriptions = this.paymentMethods
          .filter(x => this.form.payment_methods.includes(x.name))
          .map(x => x.description)
          .join(',');

        data.COVENANTS_DESCRIPTIONS = `'${covenantsDescriptions}'`;
      }

      if (!_.isEmpty(this.form.state)) {
        data.STATUS_DESCRIPTION = this.states.find(
          state => state.value === this.form.state
        )?.description;

        data.STATUS = this.form.state;
      }

      Api.report(data)
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          $(this.$refs.viewer).attr('src', window.URL.createObjectURL(blob));
          $(this.$refs.modal).modal('show');
        })
        .catch(error => {
          this.showError = true;
          throw error;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
